"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Button_1 = require("./Button");
const CollaboratorIcons_1 = require("./CollaboratorIcons");
const store_1 = require("./store");
const element_scss_1 = __importDefault(require("./styles/element.scss"));
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
function Header() {
    const dispatch = react_redux_1.useDispatch();
    const debug = React.useCallback(() => {
        dispatch(store_1.actions.incrementVersion());
    }, []);
    return (React.createElement("header", { className: classnames_1.default(flex_scss_1.default.horizontal, element_scss_1.default.header) },
        React.createElement(Button_1.IconButton, { name: "menu", vertical: true }, "Menu"),
        React.createElement("span", null, "TITLE"),
        React.createElement(CollaboratorIcons_1.CollaboratorIcons, null),
        React.createElement(Button_1.IconButton, { name: "cloud", onClick: debug }, "Debug"),
        React.createElement(Button_1.IconButton, { name: "publish", primary: true }, "Publish"),
        React.createElement(Button_1.IconButton, { name: "close", primary: true }, "Save and Exit"),
        React.createElement(Button_1.IconButton, { name: "settings_applications", vertical: true }, "Settings")));
}
exports.Header = Header;
